import OnboardingComponent from "../components/Onboarding";

export default function OnboardingPage() {
  return <OnboardingComponent />;
}
